import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import ProductInfoItem from "../../../../../../components/ProductInfoItem";
import { Product } from "../../../../../../models/Product";
import ProductItem from "../ProductItem";

export default class SiteItem extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    isView,
    hideSelect,
    isSelected = true,
    siteId,
    siteUrl,
    siteLogo,
    products = [],
    onSelect = () => { },
    onChange = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("SiteItem", {
        "hide-select": hideSelect || isView,
      }),
      siteUrl: siteUrl,
      siteLogo: siteLogo || `https://www.google.com/s2/favicons?sz=24&domain=${siteUrl}`,
      checked: isSelected ? "checked" : ""
    }, true, defaultLoading);
    this.isView = isView;
    this.hideSelect = hideSelect;
    this.siteId = siteId;
    this.siteUrl = siteUrl;
    this.siteLogo = siteLogo;
    this.onSelect = onSelect;
    this.onChange = onChange;
    /** @type {[Product]} */
    this.products = products;
    /**@type {[ProductItem]} */
    this.productItems = [];
    this.defaultLoading = defaultLoading;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "SiteItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.fillData();
    this.addEvent();
  }

  fillData() {
    let hasUnselect = false;
    let isLast = false;
    this.productItems = [];
    $(".products-list", this.element).html("");
    this.products.forEach((element, index) => {
      isLast = index === this.products.length - 1;
      if (element.type === Product.TYPE_PRODUCT.UNSELECT.id) {
        hasUnselect = true;
      }
      if (this.isView) {
        this.productItems.push(new ProductInfoItem({
          parent: $(".products-list", this.element),
          productItem: element,
          hideHead: true,
          defaultLoading: this.defaultLoading,
        }))
      } else {
        this.productItems.push(new ProductItem({
          parent: $(".products-list", this.element),
          product: element,
          isNotSelect: this.hideSelect,
          isSelected: element.canSelected(),
          isLast: isLast,
          onSelect: (e) => this.onSelect(e),
          onChange: (product) => {
            typeof this.onChange == "function" && this.onChange(product);
          },
          defaultLoading: this.defaultLoading,
        }))
      }
    });
    this.setSelected(!hasUnselect);
  }

  addProduct(product) {
    let ind = this.products.findIndex(item => item.id === product.id);
    if (ind > -1) {
      this.products[ind] = product;
    } else {
      this.products.push(product);
    }
    this.fillData();
  }

  addEvent() {
    $("input[name=checkSite]", this.element).on("change", (e) => {
      this.onChangeSelect(e.target.checked);
      typeof this.onSelect == "function" && this.onSelect(this.element);
    })
  }

  onChangeSelect(isSelect) {
    this.setSelected(isSelect);
    this.productItems.forEach(element => {
      element.setSelected(isSelect);
    });
  }

  getSelected() {
    return $("input[name=checkSite]", this.element).is(':checked');
  }

  setSelected(isChecked) {
    $("input[name=checkSite]", this.element).prop('checked', isChecked);
  }

  getProductsSelected() {
    let result = []
    this.productItems.forEach(element => {
      if (element.getSelected()) {
        result.push(element.product.id)
      }
    });
    return result;
  }
}